/**
 * This is the main entry point of the Javascript.
 * It initializes the necessary components.
 */

import Embed from "./components/Embed";
import Faq from "./components/Faq";
import Sliders from "./components/Sliders";
import Videos from "./components/Videos";



document.addEventListener("DOMContentLoaded", () => {

    const loadingScreen = document.getElementById('loading-screen');
    
    window.addEventListener('load', function() {
        loadingScreen.style.display = 'none'; // Ukrywa warstwę po załadowaniu strony
    });

    Sliders();
    Embed();
    Faq();
    Videos();
	
    const burger      = document.querySelector('.burger-js');
    const burgerMenu  = document.querySelector('.burger-menu');
    const closeBurger = document.querySelector('.burger-menu__top-close');
    const allIds      = document.querySelectorAll('a[href^="#"]');
    const faqFirst    = document.querySelector('#first-faq-element')
    const deviceAnimation = document.querySelector('.custom-device-animation');

    const items = document.querySelectorAll('.for-who__wrapper-items-item');
    const descriptions = document.querySelectorAll('.for-who__wrapper-items-description-item');
    
    if (items) {
        items.forEach(item => {
            item.addEventListener('click', () => {
                const index = item.getAttribute('data-index');
                if (index) {
                    const matchedDescriptions = document.querySelectorAll(`.for-who__wrapper-items-description-item[data-index="${index}"]`);
                    const group = index < 4 ? 'group1' : 'group2';
    
                    const groupItems = [...items].filter(el => (el.getAttribute('data-index') < 4) === (group === 'group1'));
                    const groupDescriptions = [...descriptions].filter(desc => (desc.getAttribute('data-index') < 4) === (group === 'group1'));
    
                    groupItems.forEach(el => el.classList.remove('active'));
                    groupDescriptions.forEach(desc => {
                        desc.style.maxHeight = null;
                        desc.classList.remove('active');
                    });
    
                    item.classList.add('active');
    
                    matchedDescriptions.forEach(description => {
                        description.classList.add('active');
                        const contentHeight = description.scrollHeight;
                        description.style.maxHeight = contentHeight + 'px';
                    });
                }
            });
        });
    }

    if(deviceAnimation) {
        document.addEventListener('scroll', () => {
            const container = document.querySelector('.image-slider-container');
            const topImage = document.querySelector('.image-top');
            
            const rect = container.getBoundingClientRect();
            const windowHeight = window.innerHeight;

            if (rect.top >= windowHeight) {
                topImage.style.clipPath = 'inset(0 0 0 100%)';
            } else if (rect.top < windowHeight && rect.bottom > 0) {
                const visibleHeight = Math.max(0, Math.min(rect.height, windowHeight - rect.top));
                const revealPercent = (visibleHeight / rect.height) * 100;
                topImage.style.clipPath = `inset(0 0 0 ${Math.max(0, 100 - revealPercent)}%)`;
            }
        });
    }

    if(faqFirst) {
        faqFirst.addEventListener("click", function (e) {
            e.preventDefault();

            const targetElement = document.getElementById('contact-module');

            console.log(targetElement)

            if (targetElement) {
                window.scrollTo({
                    top: targetElement.offsetTop - 30,
                    behavior: "smooth",
                });
            }
        });
    }

        // Scroll smoothly to element with ID
    if (allIds) {
        allIds.forEach(anchor => {
            anchor.addEventListener('click', function (event) {
                event.preventDefault();

                const targetId = this.getAttribute('href');
                if (targetId && targetId.startsWith('#') && targetId.length > 1) {
                    const targetElement = document.querySelector(targetId);
                    if (targetElement) {
                        const yOffset = -50; // Odstęp 100px od góry
                        const yPosition = targetElement.getBoundingClientRect().top + window.pageYOffset + yOffset;

                        window.scrollTo({
                            top: yPosition,
                            behavior: 'smooth'
                        });
                    }
                }
            });
        });
    }

    // if (allIds) {
	// 	allIds.forEach((anchor) => {
	// 		anchor.addEventListener("click", function (e) {
	// 			e.preventDefault();

	// 			const targetId = this.getAttribute("href").substring(1);
	// 			const targetElement = document.getElementById(targetId);

	// 			if (targetElement) {
	// 				window.scrollTo({
	// 					top: targetElement.offsetTop - 30,
	// 					behavior: "smooth",
	// 				});
	// 			}
	// 		});
	// 	});
	// }

    if(burger) {
        burger.addEventListener('click', function() {
            if(burgerMenu) {
                if(burgerMenu.classList.contains('active')) {
                    burgerMenu.classList.remove('active');
                } else {
                    burgerMenu.classList.add('active');
                }
            }
        })
    }

    if(closeBurger) {
        closeBurger.addEventListener('click', function() {
            if(burgerMenu) {
                if(burgerMenu.classList.contains('active')) {
                    burgerMenu.classList.remove('active');
                } else {
                    burgerMenu.classList.add('active');
                }
            }
        })
    }



});
